import React from 'react'
import Navbar from './components/navbar'
import "./App.css";
import Center from './components/center';
import Footer from './components/footer';

const App = () => {
  return (
    <>
      <Navbar/>
      <Center/>
      <Footer/>
    </>
  )
}

export default App
